import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c(VDialog,{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.$store.state.Loader),callback:function ($$v) {_vm.$set(_vm.$store.state, "Loader", $$v)},expression:"$store.state.Loader"}},[_c(VCard,{attrs:{"color":_vm.getThemeColor,"dark":""}},[_c(VCardText,[_vm._v(" "+_vm._s(_vm.message)+" "),_c(VProgressLinear,{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }